/**
 * Client Supabase BUROK APP (Expo) — lecture publique short_links via RPC.
 * Project: xdmwmfswudrxvffzsaoe
 *
 * Requis dans `.env` :
 *   VITE_BUROK_APP_SUPABASE_URL
 *   VITE_BUROK_APP_SUPABASE_ANON_KEY
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = (
  import.meta.env.VITE_BUROK_APP_SUPABASE_URL as string | undefined
)?.trim();
const SUPABASE_ANON_KEY = (
  import.meta.env.VITE_BUROK_APP_SUPABASE_ANON_KEY as string | undefined
)?.trim();

let client: SupabaseClient | null = null;

export function isBurokAppSupabaseConfigured(): boolean {
  return Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
}

export function getBurokAppSupabase(): SupabaseClient {
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    throw new Error(
      'Supabase BUROK APP non configuré : définir VITE_BUROK_APP_SUPABASE_URL et VITE_BUROK_APP_SUPABASE_ANON_KEY'
    );
  }
  if (!client) {
    client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: { persistSession: false, autoRefreshToken: false },
    });
  }
  return client;
}
